/**
 * Componente para mantener las rutas con hooks
 * 
 * @author Joel Martinez <joel.martinez@mxmart.mx>
 * @version 1.0 12/05/2021
 */
 import { createBrowserHistory } from 'history';
 export default createBrowserHistory();